/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'

import Deal from '../deal'
import { trackKevelEvent } from '~/utils/kevel-tracking'

const Tenancy = ({
  tenancy,
  ecommerce,
  intent,
  list,
  criticalJs,
  hasUspAnimated,
  setHasUspAnimated,
  cityFibreDealsAvailable
}) => {
  const {
    position,
    display: { adType, deal, kevelClickUrl, kevelImpressionUrl }
  } = tenancy

  useEffect(() => {
    trackKevelEvent(kevelImpressionUrl)
  }, [])

  const ecomm = ecommerce || {
    trackClick: () => {}
  }

  const placementType = `p${position.position}`

  return (
    <Deal
      deal={deal}
      tenancy={tenancy || {}}
      isSponsored
      ecommerce={ecomm}
      position={position.position}
      list={list}
      placementType={placementType}
      adType={adType}
      kevelClickUrl={kevelClickUrl}
      criticalJs={criticalJs}
      hasUspAnimated={hasUspAnimated}
      setHasUspAnimated={setHasUspAnimated}
      cityFibreDealsAvailable={cityFibreDealsAvailable}
    />
  )
}

export default Tenancy
